// Dependecies
import { createStore, createHook } from 'react-sweet-state';

const initialState = {
  message: '',
};

const actions = {
  getCompany:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/companies/static/search', options);
          const companies = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ array: companies });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  update:
    (data, token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch('/api/bread/jwt/companies/static/update', options);
          const garageWorkShopResponse = await response.json();

          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ status: garageWorkShopResponse.status });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getVehicles:
    (token) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };
          const response = await fetch('/api/bread/jwt/vehicles/static/search_vehicles', options);
          const res = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ array: res.vehicles, num: res.num, plans: res.plans });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getTypeService:
    (token, locale, search) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/service_types/static/search?search=${search}&&lang=${locale}`,
            options
          );
          const vehicleSystem = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ itemSystem: vehicleSystem[locale] });
            resolve(getState().itemSystem);
          }
        } catch (e) {
          reject(e);
        }
      }),
  getDates:
    (token, locale) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/services/static/enabled_dates?lang=${locale}`,
            options
          );
          const serviceDisabled = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ arrayDateDisabled: serviceDisabled.arrayDateDisabled });
            resolve(getState());
          }
        } catch (e) {
          reject(e);
        }
      }),
  getDate:
    (token, locale, data) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/services/static/enabled_date?lang=${locale}`,
            options
          );
          const serviceDisabled = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ dateDisabled: serviceDisabled.dateDisabled });
            resolve(getState().dateDisabled);
          }
        } catch (e) {
          reject(e);
        }
      }),
  getGarage:
    (token, locale, data) =>
    ({ getState, setState }) =>
      new Promise(async (resolve, reject) => {
        try {
          const options = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              Authorization: `bearer ${token}`,
            },
          };

          const response = await fetch(
            `/api/bread/jwt/garage_workshops/static/filter_garage_workshop?lang=${locale}`,
            options
          );
          const garageWorkshop = await response.json();
          if (response.status !== 200) {
            reject(response);
          } else {
            setState({ garageWorkshops: garageWorkshop.garageWorkshops });
            resolve(getState().garageWorkshops);
          }
        } catch (e) {
          reject(e);
        }
      }),
};

const Store = createStore({
  initialState,
  actions,
  name: 'company',
});

export default createHook(Store);
